import { render } from "./ErrServerError.vue?vue&type=template&id=27505d02&scoped=true"
import script from "./ErrServerError.vue?vue&type=script&lang=js"
export * from "./ErrServerError.vue?vue&type=script&lang=js"

import "./ErrServerError.vue?vue&type=style&index=0&id=27505d02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27505d02"]])

export default __exports__